import React, { useState } from 'react';

const countries = [
  { code: 'IT', name: 'Italia', flag: '🇮🇹', dialCode: '+39', available: true },
  { code: 'ES', name: 'España', flag: '🇪🇸', dialCode: '+34', available: false },
  { code: 'FR', name: 'France', flag: '🇫🇷', dialCode: '+33', available: false },
  { code: 'GB', name: 'England', flag: '🇬🇧', dialCode: '+44', available: false },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', dialCode: '+49', available: false }
];

function CountrySelection({ onCountrySelect }) {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleSelect = (country) => {
    setSelectedCountry(country);
    // Always call onCountrySelect - let parent decide what to do
    onCountrySelect(country);
  };

  return (
    <div className="screen-container">
      <div className="content-card">
        <div className="logo-container">
          <div className="logo">H</div>
          <div className="logo-text">Homie</div>
          <p className="tagline">Track all your shippings in one place</p>
        </div>
        
        <p className="subtitle">Select your country to get started</p>
        
        <div className="country-dropdown-container">
          <label className="country-select-label">Select your country:</label>
          <div className="country-dropdown-wrapper">
            <select
              className="country-select"
              value={selectedCountry?.code || ''}
              onChange={(e) => {
                const country = countries.find(c => c.code === e.target.value);
                if (country) {
                  handleSelect(country);
                }
              }}
            >
              <option value="" disabled>Choose a country...</option>
              {countries.map(country => (
                <option
                  key={country.code}
                  value={country.code}
                >
                  {country.flag} {country.name}
                </option>
              ))}
            </select>
            <div className="country-select-arrow">▼</div>
          </div>
          
          {selectedCountry && !selectedCountry.available && (
            <div className="country-unavailable-notice">
              <span className="notice-icon">ℹ️</span>
              <span>We're coming to {selectedCountry.name} soon! Join our waitlist to be notified.</span>
            </div>
          )}

          {selectedCountry && selectedCountry.available && (
            <button 
              className="submit-button" 
              onClick={() => onCountrySelect(selectedCountry)}
              style={{ marginTop: '16px' }}
            >
              Continue
            </button>
          )}

          {selectedCountry && !selectedCountry.available && (
            <button 
              className="submit-button" 
              onClick={() => onCountrySelect(selectedCountry)}
              style={{ marginTop: '16px' }}
            >
              Join Waitlist
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CountrySelection;
